import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { Bloqueio, Default, Oportunidade } from './Views';
import Contrato from './Views/Contrato';

const md = new MobileDetect(window.navigator.userAgent);

class AgendamentoEdicaoFactory extends XAPPComponent {

    renderView = (_AView) => {
        switch (_AView) {
            case "Contrato":
                return (
                    <Contrato
                        {...this.props}
                    />
                );
            case "Oportunidade":
                return (
                    <Oportunidade
                        {...this.props}
                    />
                );
            case "Bloqueio":
                return (
                    <Bloqueio
                        {...this.props}
                    />
                );
            case "Default":
                return (
                    <Default
                        {...this.props}
                    />
                );
            default:
                return (
                    <Default
                        {...this.props}
                    />
                );
        }
    }

    render() {

        const { view = "default" } = this.props;

        return (
            <React.Fragment>
                {this.renderView(view)}
            </React.Fragment>
        );
    }
}


export default AgendamentoEdicaoFactory;
